import React, { Component } from 'react';
import "./category.css"
import   SideNav from "./../../component/sidenav/sidenav.js"
import  AuthService  from "../api/authentication.js";
import   Categories from "./categoreis.js"
import  Moble from "./../../component/sidenav/moble.js"
  const  Auth =    new  AuthService
class Category extends Component {

    constructor(props) {
        super(props);
        
        this.state = {
      
          loading:false,
          noerorrpage :  true,
          loadingcategory : true,
          categories :[],
          domain: 'https://uvune-listing.herokuapp.com',  
          groups : [] ,
          getGroup :""
          
        };
        
    
      }
    componentDidMount(){
        this.props.noerorrpage(this.state.noerorrpage)
        // console.log("get payment",  Auth.getProfile().userId)
        const requestOptions = {
            method: 'GET', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
        };
        fetch(this.state.domain+"/category-group?$limit=30/", requestOptions)
          .then(result => result.json())
          .then((result)=>{
            //  console.log("res=================== group", result)
            this.setState({
              loading :true,
              groups : result.data,
            
         })
        // fetch(this.state.domain+"/category", requestOptions)
        // .then(res => res.json())
        // .then((res)=>{
        //     if(res){
        //         console.log("res===================", res)
        //         this.setState({
        //              loading :true,
        //              categories : res.data,
        //              company:  result.company_id
        //         })
        //     }else{
        //         this.setState({
        //           loading   :false
        //         }) 
        //     }
        // })

      })
      fetch(this.state.domain+"/category?$limit=30/", requestOptions)
               .then(result => result.json())
               .then((result)=>{
                 if(result){
                      // console.log("category state============ ", result)
                    const tuitionData = result.data;
                    //const tuitionData = [];
                    const allCompletedTuitions = [];
                     tuitionData.forEach( (tuition, index) => {
                        // console.log(`member --- ${index} =>`, tuition );
                        fetch(this.state.domain+"/category-group/"+ tuition.group_id, requestOptions)
                        .then(res => res.json())
                        .then((res)=>{
                            if(res){
                              //  console.log("category state============ ", res)
                              if(  res.code === 400){
                             
                                    
                                    let completeTuition = {
                                        ...tuition,
                                        category: {
                                           category : false
                                        }
                                    }
                                    // console.log("complet tuition", completeTuition);
        
                                    allCompletedTuitions.push(completeTuition);
                                    // console.log("result payment", result.data)
                                    this.setState({
                                        // loadingedit:true,
                                        // noticeshow : true,
                                        loading :true,
                                        categories : res.data,
                                        company:  res.company_id,
                                        categories:allCompletedTuitions,
                                        // loading:false
                                        //  check : false
                                    })
                              }else{
                                let category =  res;
                                
                                    let completeTuition = {
                                        ...tuition,
                                        category: {
                                            ...category
                                        }
                                    }
                                    // console.log("complet tuition", completeTuition);
        
                                    allCompletedTuitions.push(completeTuition);
                                    // console.log("result payment", result.data)
                                    this.setState({
                                      loading :true,
                                        categories : res.data,
                                        company:  res.company_id,
                                        // loadingedit:true,
                                        // noticeshow : true,
                                        categories:allCompletedTuitions,
                                        // loading:false
                                        //  check : false
                                    })

                              }
                            }else{
                                this.setState({
                                    // loadingTuition :true
                                }) 
                            }
                        })
    
                     })
                     
                    //  this.getData(result)
                    
                 }else{
                    this.setState({
                        check : true
                    })
                 }
               }).catch( (error) => {
                 //  console.log("errro", error);
                  // console.log("error load", "check", this.state.check )
             });
        // console.log("categories", this.state.categories)
    }
    addCategory=(e)=>{
        e.preventDefault();
        
        this.setState({
            loadingcategory :false
        }) 
        
        const data ={
            // title:this.title.value,
            name  :this.name.value,
            group_id :  this.state.getGroup,
            company_id : this.props.user.company_id
         }
        //  console.log("data", data)
         const requestOptions = {
          method: 'POST', 
          headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
          body: JSON.stringify(data),
        };

        fetch(this.state.domain+"/category", requestOptions)
        .then(res => res.json())
        .then((res)=>{
          console.log("data--->res", res)
            if(res){
              const categories  = this.state.categories
              categories.push({
                        name: this.name.value,   
                        // group_id: this.group.value,
                        createdAt: res.createdAt,
                        _id : res._id
                    })
                // console.log("res", res)
                this.setState({
                    loadingcategory:true, 

                })
            }else{
                this.setState({
                    loadingcategory :false
                }) 
            }
            this.name.value = ""
            // this.description.value = ""
        })
    }

    editpeyer=(data)=>{
        // console.log("edit" ,data)
            
      const requestOptions = {
          method: 'PATCH', 
          headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
          body: JSON.stringify(data),
        };

        fetch(this.state.domain+"/category/" + data.id, requestOptions)
            .then(res => res.json())
            .then((result)=>{
              if(result){
                  // console.log("result", result)
                  this.setState({
                      loadingedit:true,
                      noticeshow : true,
                      noticeMassage : "Updated"
                  })
                  this.timeout() 
              }
            }).catch( (error) => {
              //  console.log("errro", error);
              // console.log("error load", error )
          });

          this.setState({
              loadingedit:false,
              noticeMassage : "Failed to Update"
          }) 

    }

    onDelete = (data) => {
        const requestOptions = {
            method: 'DELETE', 
            headers: { 'Content-Type':'application/json','Access-Control-Allow-Origin': '*' ,'Authorization': Auth.getToken()  },
            // body: JSON.stringify(dataedit),
          };
        // console.log("dalete", data)
        fetch(this.state.domain+"/category/"+ data, requestOptions)
          .then(res => res.json())
          .then((result)=>{
            if(result){
                // console.log("result", result)
                this.setState({
                    loadingedit:true,
                    noticeshow : true,
                    noticeMassage : "Delete"
                })
                this.timeout() 
                const   categories  = this.state.categories
                const fitlereddata =    categories.filter(  category =>{
                    return  category._id !== data
                  })
                // console.log(fitlereddata)
                this.setState({ categories:fitlereddata})
            }
          }).catch( (error) => {
            //  console.log("errro", error);
            //  console.log("error load", error )
        });

        this.setState({
            // loading:false ,
            noticeMassage : "Failed to Delete"
        })  
    }

    timeout() {
        setTimeout(function() {
            this.setState({
                noticeshow : false
            })
          // console.log(this.state.noticeshow);
        }.bind(this), 4000);
    }

    selectCategory = (e)=>{
      // console.log("data--===------> category", e.target.value)
      this.setState({
        getGroup: e.target.value
      })
    
    }
    
    Showcategory= (e)=>{
      e.preventDefault()
      this.setState({
         showCategory: true
      })
    }
    
      

  render() {
    // console.log(this.props.user)
    // var divStyle = {
    //     color: 'white',
    //     background: "red",
    //     height:"auto",
    //     WebkitTransition: 'all', // note the capital 'W' here
    //     "margin-top":"110px"
        
    //   };
  //  console.log("datata--==---->", this.state.categories )
    return (
             <div id="dashboard-wrapper " class="columns dashboard-cousom">
              <div class="column"></div>
              <div class="content column is-11">
          
                  {/* <!-- Breadcrumbs --> */}
                  <nav class="breadcrumbs">
                      {/* <button onClick={this.clickeme}>click</button> */}
                      <ul>
                          <li><a href="/">Home</a></li>
                          <li>Categories</li>
                      </ul>
                  </nav>
                  {/* <!-- /Breadcrumbs -->
          
                  <!-- Dashboard Wrapper --> */}
                  <div class="dashboard-wrapper">
                      <div class="columns">
                        <div class="column is-three-fifths">
                         <div>
                         <div className="category-title-phoneAddhead"> 
                        <i className="fas fa-tags">  </i>   Categories 
                            
                         </div>
                           <div className="category-body">
                           {
                                    this.state.categories.length > 0 ? (
                                      <ul className="responsive-table">
                                 
                                      <li className="table-header">
                                        <div className="col col-1">Name</div>
                                        {/* <div className="col col-2">   Description</div> */}
                                        <div className="col col-3">  </div>
                                        
                                      </li>
                                        { this.state.loading  ?
                                            <div>
                                                 {
                                               this.state.categories.map( category=>{
                                                            
                                                  return(
                        

                                                    <   Categories  
                                                        key={category._id}
                                                        category={category}
                                                        name={category.name}
                                                        groups={this.state.groups}
                                                        date={category.createdAt}
                                                        id={category._id}
                                                        editpeyer={this.editpeyer}
                                                        onDelete={this.onDelete}
                                                    
                                                    />

                                                    // <li className="table-row"   key={ category._id}>

                                                    //     <div className="col col-1" data-label="Job Id">{category.title}</div>
                                                    //     <div className="col col-2" data-label="Customer Name">{category.description}</div>
                                                    //     <div className="col col-3" data-label="Customer Name">{category.createdAt}</div>
                                                    // </li>
                                                  )
    
                                                })  
                                            }
                                            </div>
                                          :
                                            <div>
                                                <div className="level-item">
                                                    <a className="button is-loading is-large is-light">Loading</a>
                                                </div>  
                                                <br/>
                                            </div>
                                        }
                                     
                                     
                                     
                                    </ul>
                                    ):
                                    (<p>No Category</p>)

                               }
                            
                           </div>
                        
                         {/* <div class="flex-card category-card light-bordered">
                            <div class="card-body">
                              
                                  
                                  <h2 class="title is-5">Team management</h2>
                                  <div class="inner-text">
                                      Our app let's you manage your team members smoothly. You can add users to your team in few clicks.
                                  </div>
                                        
                                
                            </div>
                        </div> */}
                         
                        </div>
                        </div>
                            <div class="column">
                            <div class="flex-card light-bordered light-raised">
                          
                            <div class="content has-text-centered mt-20">
                                <h3>New Category</h3>
                            </div>
                            <div class="card-body">
                            <form onSubmit={this.addCategory} >
                                <div class="control-material is-secondary">      
                                        <input class="material-input"  ref={ input => this.name = input} 
                                    onChange={this.handleChange} type="text"   required/>
                                        <span class="material-highlight"></span>
                                        <span class="bar"></span>
                                        <label>Category name</label>
                                  </div>
                                  {
                                      this.state.groups?
                                       <div>
                                       {
                                             this.state.groups .length > 0 ? (
                                              <div class="columns">
                                         
                                              <div class="column is-one-third">categoeris:</div>
                                              <div class="column">
                                                <div class="field">
                                                  <div class="control">
                                                    <div class="select is-small">
                                                      <select onChange={this.selectCategory}  class="form-control" value={this.state.getGroup}>
                                                                    {/* <option value={this.state.getfirstCate._id}>{this.state.getfirstCate.name}</option> */}
                                                                    {
                                                                          this.state.groups.map(data => {
                                                                              return  <option key={data._id} value={data._id}>{data.name}</option>
                                                                          })
                                                                      }
                                                                
                                                                            
                                                      </select>
                                                      {/* <select>
                                                        <option value="">--- Please select ---</option>
                                                        <option>With options</option>
                                                      </select> */}
                                                    </div>
                                                  </div>
                                                </div>
                                            </div>
                                          </div>
                                            )
                                         :
                                         <div></div>
                                       }
                                          
            
                                   </div>
                                   :
                                   <div></div>
                                     }
                                  {/* <div class="control-material is-secondary">      
                                        <input class="material-input"  ref={ input => this.group = input} 
                                    onChange={this.handleChange} type="text"   required/>
                                        <span class="material-highlight"></span>
                                        <span class="bar"></span>
                                        <label>Category name</label>
                                  </div> */}
                                    {
                                       this.state.loadingcategory ?
                                        <div class="mt-20 has-text-right">
                                            <button type="submit" class="button btn-align info-btn raised">SUBMIT</button>
                                        </div>
                                    :
                                    <div className="level-item">
                                        <a className="button is-loading is-large is-light">Loading</a>
                                    </div> 
                            
                                    }
                                </form>
                            </div>
                        </div>
                        
                        </div>
                        
                      </div>
                   </div>
              
              </div>
           </div>     

    )

}





}

export default Category ;


// WEBPACK FOOTER //
// ./src/component/category/category.js